import { render, staticRenderFns } from "./ClusterNotificationProviderForm.vue?vue&type=template&id=f10b8536"
import script from "./ClusterNotificationProviderForm.vue?vue&type=script&lang=js"
export * from "./ClusterNotificationProviderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports